import Intercom from "@intercom/messenger-js-sdk";

const APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;

// ...

export const initIntercom = (userId, userHash) => {
  Intercom({
    app_id: APP_ID,
    hide_default_launcher: true, // 隐藏默认 Intercom 图标
    vertical_padding: 60,
    user_id: userId,
    user_hash: userHash
  })
}